import { render } from "./BookingUnderApprovalApproveModal.vue?vue&type=template&id=1c2cd6a2&scoped=true"
import script from "./BookingUnderApprovalApproveModal.vue?vue&type=script&lang=js"
export * from "./BookingUnderApprovalApproveModal.vue?vue&type=script&lang=js"

import "./BookingUnderApprovalApproveModal.vue?vue&type=style&index=0&id=1c2cd6a2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2cd6a2"]])

export default __exports__